import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat } from 'google-libphonenumber';
import * as T_T from 'cryface';

export class ContactAgentFormatter {
    public formatDemo(value: any, event: any) {
        return value.toLowerCase();
    }
    public phone(value: any, event: any) {
        const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
        try {
            const numberProto: PhoneNumber = phoneUtil.parse(value, 'CA');
            return phoneUtil.format(numberProto, PhoneNumberFormat.E164);
          } catch (e) {
              console.error(`Invalid Phone Number Format--------------${value}`);
          }
    }
}
